'use strict';

export default function SignupService($http, $cookies, $state) {
    'ngInject';
    let Signup = {
        verify(data) {
            // console.log('SignupService -> verify -> ', data);
            return $http.post(`/api/users/verify/${data.invitedUserId}`, {code: data.code})
            .then((response) => {
                console.log('Phone verified successfully');
                return response.data;
            })
            .catch(err => {
                console.log('SignupService -> verify -> ', err);
                throw err;
            })
        }
    }
    return Signup;
}


// WEBPACK FOOTER //
// ./client/app/account/signup/signup.service.js